import React from "react";
import Confirmation from "../Confirmation/ConfirmationPage";

export default function Error() {
  return (
    <Confirmation
      title="Error"
      textAlign="text-sm-center"
      message="Something went wrong. Please check your internet and try again."
    />
  );
}
